import { render, staticRenderFns } from "./SidPositionButtons.vue?vue&type=template&id=6ffa6e90"
import script from "./SidPositionButtons.vue?vue&type=script&lang=js"
export * from "./SidPositionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports